import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { demoQuestionBank } from '../data/demoData';
import './DemoQuizPage.css';

const DemoQuizPage = () => {
  const navigate = useNavigate();
  const [questions, setQuestions] = useState([]);
  const [currentIdx, setCurrentIdx] = useState(0);
  const [selected, setSelected] = useState(null);
  const [score, setScore] = useState(0);
  const [isFinished, setIsFinished] = useState(false);

  useEffect(() => {
    const shuffled = [...demoQuestionBank].sort(() => 0.5 - Math.random());
    setQuestions(shuffled.slice(0, 5));
  }, []);

  const handleNext = () => {
    if (selected === questions[currentIdx].correct) {
      setScore(s => s + 1);
    }
    
    if (currentIdx < questions.length - 1) {
      setCurrentIdx(currentIdx + 1);
      setSelected(null);
    } else {
      setIsFinished(true);
    }
  };

  if (questions.length === 0) return null;
  const currentQ = questions[currentIdx];

  return (
    <div className="demo-page-light">
      <div className="demo-top-nav">
        <div className="brand-accent" onClick={() => navigate('/')}>Quest<span>AI</span></div>
        <div className="quest-label">Knowledge Quest</div>
      </div>

      <main className="quiz-main-card">
        <div className="quiz-progress-track">
            <div className="quiz-progress-fill" style={{ width: `${((currentIdx + 1) / 5) * 100}%` }}></div>
        </div>

        <section className="quiz-content">
          <div className="quiz-category">
            <span className="cat-icon">{currentQ.icon}</span>
            <span className="cat-text">{currentQ.cat}</span>
          </div>
          <h2 className="quiz-question-display">{currentQ.text}</h2>
          <div className="options-grid-2x2">
            {currentQ.options.map((opt, i) => (
              <button 
                key={i} 
                className={`grid-option-item ${selected === opt ? 'active-select' : ''}`}
                onClick={() => setSelected(opt)}
              >
                {opt}
              </button>
            ))}
          </div>
        </section>

        <footer className="quiz-footer-bar">
          <div className="step-indicator">Question <strong>{currentIdx + 1}</strong> of 5</div>
          <button className="next-action-btn" onClick={handleNext} disabled={!selected}>
            {currentIdx === 4 ? "Show My Score" : "Next Question"}
          </button>
        </footer>
      </main>

      {isFinished && (
        <div className="modal-result-overlay">
          <div className="modal-result-box">
            <div className="celebration-vibe">🎯</div>
            <h2 className="score-title">Quest Result</h2>
            
            <div className="score-focus-area">
                <div className="score-circle-new">
                    <span className="score-num">{score}</span>
                    <span className="score-den">/5</span>
                </div>
                <p className="score-feedback">
                    {score >= 4 ? "Outstanding! You're a natural." : "Good effort! Practice makes perfect."}
                </p>
            </div>

            <div className="perks-highlight-card">
                <p className="perks-label">REGISTER TO UNLOCK MORE</p>
                <div className="perks-row">
                    <span className="perk-pill">✓ 100+ Topics</span>
                    <span className="perk-divider">•</span>
                    <span className="perk-pill">✓ Earn Credits</span>
                    <span className="perk-divider">•</span>
                    <span className="perk-pill">✓ Redeem for Goodies</span>
                </div>
            </div>

            <div className="modal-actions-stack">
              <button className="btn-join-premium" onClick={() => navigate('/register')}>
                Register Now
              </button>
              <button className="btn-exit-lite" onClick={() => navigate('/')}>
                Back to Home
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DemoQuizPage;